import React, { useState } from 'react';

import { Button, Code, Wrap, WrapItem } from '@chakra-ui/react';

const SHOWN = 8;

/** Allowed values of an enum; long lists start collapsed. */
export const ApiFieldValues = ({ values }: { values: string[] }) => {
  const [expanded, setExpanded] = useState(false);
  const shown = expanded ? values : values.slice(0, SHOWN);
  return (
    <Wrap spacing={1} mt={1}>
      {shown.map(value => (
        <WrapItem key={value}>
          <Code fontSize="12px" px={1.5} bg="gray.100">
            {value}
          </Code>
        </WrapItem>
      ))}
      {values.length > SHOWN && (
        <WrapItem>
          <Button
            variant="link"
            size="xs"
            color="primary"
            fontWeight={400}
            onClick={() => setExpanded(!expanded)}
          >
            {expanded ? 'Show fewer' : `+${values.length - SHOWN} more`}
          </Button>
        </WrapItem>
      )}
    </Wrap>
  );
};
